module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAMAAAAs2N9uAAAAZlBMVEUAAAAre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8vVg1eeAAAAIXRSTlMA+AV859q8gWzUjnRZQy0iG/LLx62piFFPOzgm7aGSZBIU/abDAAAAiUlEQVQY02WQWxKDIAxFE1AUFXy1ttW+7v43KcJEPjwfhDkzuZOEIkM1v1HcOkWCZiTKVxLqHv6tW7sPgx9RVYBOHZsF+1B7hpaEfwkTygJLJ0+gJw3gm12BmqjFQhmDJrwrXZQgjTEzG3fEH2G1GGVh0qjihhnsZaHp5zfXjGmh69pynGk8j7MDDNgKD2aC+n0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_turn_l_hover.png
// module id = IurV
// module chunks = 9